/**
 * SKU操作Hook
 * 职责: 处理SKU的CRUD操作（包括FABE生成）
 * 限制: <150行
 */

import { useSKUDelete, useSKUSubmit, useSKUFABE } from './actions';

export const useSKUActions = (onSuccess: () => void) => {
  const { handleDelete } = useSKUDelete(onSuccess);
  const { handleSubmit } = useSKUSubmit(onSuccess);
  const {
    handleGenerateFABE,
    handleConfirmFABE,
    handleCancelFABE,
    fabeModalVisible,
    fabeLoading,
    currentSellingPoint,
    currentFABEData,
  } = useSKUFABE(onSuccess);

  return {
    handleDelete,
    handleSubmit,
    handleGenerateFABE,
    handleConfirmFABE,
    handleCancelFABE,
    fabeModalVisible,
    fabeLoading,
    currentSellingPoint,
    currentFABEData,
  };
};
